// ─── Metrics ──────────────────────────────────────────────────────
export const METRICS = [
  { id: 'ventas',      label: 'Total ventas',       color: '#5046e4', bg: '#eeecfd', value: '$84,230', delta: '+12.4%', up: true,  sub: 'vs. mes anterior' },
  { id: 'clientes',    label: 'Clientes activos',   color: '#16a34a', bg: '#f0fdf4', value: '2,841',   delta: '+8.1%',  up: true,  sub: 'este mes' },
  { id: 'ticket',      label: 'Ticket promedio',    color: '#d97706', bg: '#fffbeb', value: '$29.65',  delta: '-2.3%',  up: false, sub: 'por orden' },
  { id: 'ventas_consolidadas', label: 'Ventas consolidadas (tabla)', color: '#0f766e', bg: '#f0fdfa', value: '—', delta: null, up: null, sub: 'por canal, fecha, sucursal, grupo o evento' },
  { id: 'ventas_por_sucursal', label: 'Ventas por sucursal', color: '#0f766e', bg: '#f0fdfa', value: '—', delta: null, up: null, sub: 'por sucursal' },
  { id: 'ordenes',     label: 'Órdenes',           color: '#2563eb', bg: '#eff6ff', value: '3,109',   delta: '+5.7%',  up: true,  sub: 'este mes' },
  { id: 'metas',       label: 'Metas del mes',      color: '#dc2626', bg: '#fef2f2', value: '78%',     delta: '+3pts',  up: true,  sub: 'del objetivo' },
  { id: 'delivery',    label: 'Delivery %',         color: '#0891b2', bg: '#ecfeff', value: '68%',     delta: '+1.2%',  up: true,  sub: 'del total' },
  { id: 'productos',   label: 'Top productos',      color: '#7c3aed', bg: '#f5f3ff', value: '5',       delta: null,     up: null,  sub: 'más vendidos' },
  { id: 'actividad',   label: 'Actividad reciente', color: '#0f766e', bg: '#f0fdfa', value: '12',      delta: null,     up: null,  sub: 'eventos hoy' },
  { id: 'conversion',  label: 'Conversión',         color: '#be185d', bg: '#fdf2f8', value: '3.8%',    delta: '+0.4%',  up: true,  sub: 'de visitas' },
  { id: 'devolucion',  label: 'Devoluciones',       color: '#b45309', bg: '#fffbeb', value: '2.1%',    delta: '-0.3%',  up: true,  sub: 'del total' },
  { id: 'nps',         label: 'NPS Score',          color: '#1d4ed8', bg: '#eff6ff', value: '72',      delta: '+5pts',  up: true,  sub: 'satisfacción' },
  { id: 'churn',       label: 'Churn rate',         color: '#9f1239', bg: '#fff1f2', value: '1.4%',    delta: '-0.2%',  up: true,  sub: 'mensual' },
  { id: 'cac',         label: 'CAC',                color: '#065f46', bg: '#ecfdf5', value: '$12.40',  delta: '-4.1%',  up: true,  sub: 'costo adquisición' },
  { id: 'ltv',         label: 'LTV',                color: '#4338ca', bg: '#eef2ff', value: '$184',    delta: '+6.2%',  up: true,  sub: 'valor de vida' },
  { id: 'revenue_mrr', label: 'MRR',                color: '#0369a1', bg: '#f0f9ff', value: '$28,400', delta: '+9.1%',  up: true,  sub: 'ingreso recurrente' },
  { id: 'ops_tiempo',  label: 'Tiempo entrega',     color: '#6d28d9', bg: '#f5f3ff', value: '24min',   delta: '-3min',  up: true,  sub: 'promedio' },
];

// ─── Chart types ──────────────────────────────────────────────────
export const CHART_TYPES = [
  { id: 'kpi',        label: 'KPI',           desc: 'Número grande + delta',      category: 'basic' },
  { id: 'bar',        label: 'Barras',        desc: 'Comparación horizontal',     category: 'chart' },
  { id: 'line',       label: 'Línea',         desc: 'Tendencia en el tiempo',     category: 'chart' },
  { id: 'area',       label: 'Área',          desc: 'Línea con relleno',          category: 'chart' },
  { id: 'ring',       label: 'Anillo',        desc: 'Progreso / porcentaje',      category: 'chart' },
  { id: 'list',       label: 'Lista',         desc: 'Items con valores',          category: 'basic' },
  { id: 'bar_h',      label: 'Barras horiz.', desc: 'Ranking horizontal',         category: 'chart' },
  { id: 'scatter',    label: 'Dispersión',    desc: 'Correlación entre valores',  category: 'chart' },
  { id: 'composed',   label: 'Combinado',     desc: 'Línea + barras juntas',      category: 'chart' },
  { id: 'stat_delta', label: 'Stat + delta',  desc: 'KPI con comparativa',        category: 'basic' },
  { id: 'heatmap',    label: 'Heatmap',       desc: 'Intensidad por período',     category: 'chart' },
  { id: 'funnel',     label: 'Embudo',        desc: 'Conversión por etapa',       category: 'chart' },
  { id: 'table',      label: 'Tabla',         desc: 'Tabla consolidada',          category: 'table' },
];

// ─── Mock series ──────────────────────────────────────────────────
export const SERIES_DATA = {
  ventas:      [42,51,47,63,58,72,68,84],
  clientes:    [180,210,195,240,228,265,250,284],
  ordenes:     [1200,1450,1320,1780,1640,2010,1900,2350],
  ticket:      [28,31,29,33,30,32,28,30],
  metas:       [55,60,62,65,68,71,75,78],
  delivery:    [58,61,63,60,64,65,67,68],
  conversion:  [3.2,3.0,3.4,3.1,3.6,3.5,3.7,3.8],
  nps:         [60,63,65,67,66,69,70,72],
  revenue_mrr: [18000,19200,20100,21800,23000,24500,26200,28400],
  ltv:         [140,148,152,160,164,170,178,184],
  cac:         [16,15.5,15,14.2,13.8,13.5,13,12.4],
  churn:       [2.1,2.0,1.9,1.8,1.7,1.6,1.5,1.4],
};

export const MONTHS    = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago'];
export const TOP_LIST  = [
  { name:'Hamburguesa Clásica', value:342, pct:100 },
  { name:'Pizza Mediana',       value:298, pct:87  },
  { name:'Combo Familiar',      value:241, pct:70  },
  { name:'Wrap de Pollo',       value:189, pct:55  },
  { name:'Ensalada César',      value:156, pct:46  },
];
export const ACTIVITY_LIST = [
  { initials:'JR', color:'#5046e4', name:'Juan Rodríguez', action:'Nueva orden #4421',  time:'2m'  },
  { initials:'ML', color:'#16a34a', name:'María López',    action:'Pago confirmado',    time:'5m'  },
  { initials:'CA', color:'#d97706', name:'Carlos Aguilar', action:'Canceló #4419',      time:'12m' },
  { initials:'SV', color:'#2563eb', name:'Sofia Varela',   action:'Nueva orden #4418',  time:'18m' },
];

// ─── Layout types ─────────────────────────────────────────────────
export const LAYOUT_TYPES = [
  { id:'columns', label:'Columnas', desc:'Columnas iguales en fila' },
  // { id:'bento',   label:'Bento',    desc:'Grid asimétrico tipo bento' },
];

// ─── Column options ───────────────────────────────────────────────
export const COL_OPTIONS = [
  { cols:1, label:'1 columna',  sub:'Ancho completo' },
  { cols:2, label:'2 columnas', sub:'Mitad cada una' },
  { cols:3, label:'3 columnas', sub:'Un tercio'      },
  { cols:4, label:'4 columnas', sub:'Un cuarto'      },
];

// ─── Bento templates ──────────────────────────────────────────────
export const BENTO_TEMPLATES = [
  {
    id:'bento_2_1', label:'2 grandes + ancho',
    slots:[
      { col:1,row:1,colSpan:2,rowSpan:2 },
      { col:3,row:1,colSpan:2,rowSpan:2 },
      { col:1,row:3,colSpan:4,rowSpan:1 },
    ],
  },
  {
    id:'bento_1_3', label:'1 grande + 3 pequeños',
    slots:[
      { col:1,row:1,colSpan:2,rowSpan:3 },
      { col:3,row:1,colSpan:2,rowSpan:1 },
      { col:3,row:2,colSpan:1,rowSpan:2 },
      { col:4,row:2,colSpan:1,rowSpan:2 },
    ],
  },
  {
    id:'bento_3_1', label:'3 pequeños + 1 grande',
    slots:[
      { col:1,row:1,colSpan:1,rowSpan:2 },
      { col:2,row:1,colSpan:1,rowSpan:2 },
      { col:1,row:3,colSpan:2,rowSpan:1 },
      { col:3,row:1,colSpan:2,rowSpan:3 },
    ],
  },
  {
    id:'bento_featured', label:'Destacado central',
    slots:[
      { col:1,row:1,colSpan:1,rowSpan:2 },
      { col:2,row:1,colSpan:2,rowSpan:2 },
      { col:4,row:1,colSpan:1,rowSpan:2 },
    ],
  },
];

export const buildLayoutFromRows = (rows) => {
  const layout = []; let y = 0;
  rows.forEach((row, ri) => {
    const colW = Math.floor(12 / row.cols);
    row.slots.forEach((slot, ci) => {
      layout.push({ i:`r${ri}c${ci}`, x:ci*colW, y, w:colW, h:slot?.chartType==='kpi'?3:4, minW:2, minH:3 });
    });
    y += (row.slots.some(s=>s?.chartType!=='kpi') ? 4 : 3);
  });
  return layout;
};
